import React from 'react';
import { Box, GridItem } from '@chakra-ui/react';

const Pickup = () => {
  return (
    <Box>
      <Box as="h1" fontSize="34px" textTransform="uppercase" mb={5}>
        Pickup AMS
      </Box>
      <GridItem as="p">Application mobile de lecture numérique personnalisée</GridItem>
      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [Objectifs]
      </Box>
      <GridItem as="p">– Simplifier les parcours utilisateurs sur l’application AMS utilisée dans +130 000 relais en Europe.</GridItem>
      <GridItem as="p">– Concevoir une interface mobile-first, claire et efficace pour les flux de colis (scan, dépôt, retrait, erreurs…)</GridItem>
      <GridItem as="p">– Créer une bibliothèque d’illustrations fonctionnelles pour améliorer la lisibilité des actions métier</GridItem>
      <GridItem as="p">– Adapter l’UX aux contraintes terrain (gestes rapides, hiérarchie visuelle, lisibilité contextuelle)</GridItem>
      <GridItem as="p">- Concevoir un parcours d’onboarding pour guider l’utilisateur lors de tâches complexes.</GridItem>
    </Box>
  );
};

export default Pickup;
